if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector('[data-name="id"]').disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
        this.skipCart = this.dataset.skipCart === "true";
        this.hasPopup = !!document.getElementById("add-to-cart-popup");
        this.popup = document.getElementById("add-to-cart-popup");
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;
        this.handleErrorMessage();

        if (this.hasPopup) {
          // Führe die Button-Animation aus
          this.submitButton.setAttribute("aria-disabled", true);
          this.submitButton.classList.add("loading");
          this.querySelector(".loading__spinner").classList.remove("hidden");

          // Öffnen des Popups
          this.openPopup();
        } else {
          // Führe den normalen Add-to-Cart-Vorgang ohne Popup aus
          this.submitButton.setAttribute("aria-disabled", true);
          this.submitButton.classList.add("loading");
          this.querySelector(".loading__spinner").classList.remove("hidden");
          this.addToCart();
        }
      }

      openPopup() {
        this.popup.classList.add("show");
        document.body.style.overflow = "hidden";
        const confirmButton = this.popup.querySelector(".confirm-button");
        confirmButton.addEventListener(
          "click",
          () => {
            this.addToCart();
            this.closePopup();
          },
          { once: true }
        );
      }

      closePopup() {
        this.popup.classList.remove("show");
        document.body.style.overflow = "";
      }

      dispatchCustomEvent(eventName, detail = {}) {
        const event = new CustomEvent(eventName, {
          bubbles: true,
          cancelable: true,
          detail: detail,
        });
        return this.dispatchEvent(event);
      }

      addToCart() {
        const shouldContinue = this.dispatchCustomEvent("beforeAddToCart", {
          form: this.form,
        });
        if (!shouldContinue) return; // Bricht ab, wenn das Event abgebrochen wird

        const timestamp = Date.now();
        var elements = document.getElementsByClassName("timestamp");
        for (var i = 0; i < elements.length; i++) {
          elements[i].value = timestamp;
        }

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (this.skipCart) {
              window.location = "/checkout";
              return;
            }

            if (!this.error) this.cart.renderContents(response);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner").classList.add("hidden");

            if (
              typeof fpInstance !== "undefined" &&
              fpInstance !== null &&
              fpInstance.config &&
              fpInstance.config.minDate
            ) {
              var today = new Date();
              var minDate = new Date(fpInstance.config.minDate);
              var firstAvailableDate = minDate > today ? minDate : today;

              fpInstance.setDate(
                [firstAvailableDate, firstAvailableDate],
                true
              );
              document.getElementById("datum").value =
                firstAvailableDate.toLocaleDateString("de-DE");
            }

            var ausstellerTyp = document.getElementById("aussteller-typ");
            if (ausstellerTyp) {
              ausstellerTyp.value = "";
            }

            var sonstAussteller = document.getElementById(
              "sonstiger-aussteller"
            );
            if (sonstAussteller) {
              sonstAussteller.value = "";
            }

            var sonstAusstellerWrap = document.getElementById(
              "sonstiger-aussteller-wrapper"
            );
            if (sonstAusstellerWrap) {
              sonstAusstellerWrap.style.display = "none";
            }

            var kennzeichen = document.getElementById("kennzeichen-wrapper");
            if (kennzeichen) {
              kennzeichen.style.display = "block";
            }

            var kennzeichenBekannt = document.getElementById(
              "kennzeichen-bekannt"
            );
            if (kennzeichenBekannt) {
              kennzeichenBekannt.checked = false;
            }

            var kennzeichenValue = document.getElementById("kennzeichen");
            if (kennzeichenValue) {
              kennzeichenValue.value = "";
            }

            var addonCheckboxes = document.querySelectorAll(".addon-product");
            addonCheckboxes.forEach(function (addonCheckbox) {
              addonCheckbox.checked = false;
            });

            var addonVariantInputs = document.querySelectorAll(
              ".addon-product__values input"
            );
            addonVariantInputs.forEach(function (addonVariantInput) {
              addonVariantInput.disabled = true;
            });

            var quantityInputs = document.querySelectorAll(
              ".addon-product-quantity"
            );
            quantityInputs.forEach(function (quantityInput) {
              quantityInput.value = 1;
              quantityInput.disabled = true;
            });

            var addonPrice = document.querySelector(".price-item--addons");
            if (addonPrice) {
              addonPrice.style.display = "none";
            }

            globalThis.scrollTo({ top: 0, left: 0, behavior: "smooth" });
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
